import { render } from "./ModalHabitacionesBuscador.vue?vue&type=template&id=b1a9bafa&scoped=true"
import script from "./ModalHabitacionesBuscador.vue?vue&type=script&lang=js"
export * from "./ModalHabitacionesBuscador.vue?vue&type=script&lang=js"

import "./ModalHabitacionesBuscador.vue?vue&type=style&index=0&id=b1a9bafa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1a9bafa"]])

export default __exports__